
import { useRoute } from 'vue-router'
import { computed, defineComponent, nextTick, onMounted, ref, reactive, toRefs, watch } from 'vue'
import { askApi } from '@/api/index'
import { useStore } from 'vuex'
import { wsurl } from '@/api/config'
export default defineComponent({
  props: {
    sourceData: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 订阅的码表
    subonType: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  setup(props, context) {
    const pageData: any = reactive({
      websock: null,
      list: props.sourceData
    })
    pageData.list = computed(() => {
      return props.sourceData
    })
    websocket()
    function websocket() {
      pageData.websock = new WebSocket(wsurl)
      pageData.websock.onopen = websocketonopen
      // 接收信息
      pageData.websock.onmessage = websocketonmessage
    }
    function websocketonopen() {
      const data = {
        OrgCode: 'rh',
        Token: 'e9252a64-6ac8-4bf8-9725-6f106f682908',
        AppName: 'fdzqapp',
        AppVer: 'V3.0.9',
        AppType: 'ios',
        Tag: 'af91c60a-1acc-4150-9014-d11086cb9489'
      }
      websocketsend(JSON.stringify(data))
    }
    function websocketsend(msg: any) {
      if (pageData.websock && pageData.websock.readyState) {
        pageData.websock.send(msg)
      }
    }
    function websocketonmessage(event: any) {
      context.emit('message', event)
    }
    // 源数据去重
    const removeDuplicateObj = (arr: any) => {
      const newArr: any = []
      for (const t of arr) {
        // 检查缓存中是否已经存在
        if (newArr.find((c: any) => c.symbol === t.symbol && c.market === t.market)) {
          continue
        }
        newArr.push(t)
      }
      // 记录结果就是过滤后的结果
      return newArr
    }
    // 订阅 / 取消订阅
    // 订阅
    function subon(list: any) {
      if (!list.length) return
      nextTick(() => {
        // 列表去重
        const data = removeDuplicateObj(list)
        data.forEach((item: any) => {
          props.subonType.forEach((t: any) => {
            let ReqID = 8317003
            const _data1 = {
              Market: (item.market || item.Exch || '').toLowerCase(),
              Inst: item.symbol || item.Inst,
              ServiceType: t,
              SubType: 'SUBON',
              ReqID: ReqID
            }
            ReqID++
            websocketsend(JSON.stringify(_data1))
          })
        })
      })
    }
    // 取消订阅
    function suboff(data: any) {
      const _data = data || pageData.list
      if (!_data.length) return
      const arr = removeDuplicateObj(_data)
      arr.forEach((item: any) => {
        // 取消订阅
        props.subonType.forEach((t: any) => {
          let ReqID = 8317003
          const _data1 = {
            Market: (item.market || item.Exch || '').toLowerCase(),
            Inst: item.symbol || item.Inst,
            ServiceType: t,
            SubType: 'SUBOFF',
            ReqID: ReqID
          }
          ReqID++
          websocketsend(JSON.stringify(_data1))
        })
      })
    }
    watch(
      () => pageData.list,
      (newV: any, oldV: any) => {
        suboff(oldV)
        nextTick(() => {
          subon(newV)
        })
      }
    )
    return {
      ...toRefs(pageData)
    }
  }
})
